<template>
	<div class="wrap">
		<router-view class="con_box"></router-view>

		<v-footer></v-footer>
	</div>
</template>

<script>
	import VFooter from './footer'

	export default {
		name: "index",
		components: {
			VFooter
		}
	}
</script>

<style lang="less" scoped>
	.wrap {
		width: 100%;
		height: 100%;
		background-color: @bodyBgColor;
		overflow: auto;
	}

	.con_box {
		min-height: calc(100% - @footerHeight);
	}
</style>
